import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg ref={ref} onClick={onClick} width={size} height={size} viewBox='0 0 24 24' fill='none' className={className}>
      <path d='M9 6H19' stroke={fillColor} strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M9 12H19' stroke={fillColor} strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M9 18H19' stroke={fillColor} strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M5 6H5.01' stroke={fillColor} strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M5 12H5.01' stroke={fillColor} strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M5 18H5.01' stroke={fillColor} strokeWidth='1.3' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
});

export default React.memo(Icon);
